<template>
    <section class="modal-mask modal-invite-people modal-edit-task">
        <div class="modal-mask-inner" @click="closeOpenModal"></div>
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-body">
                    <div v-if="errorMsg" class="feedback" v-html="errorMsg"></div>

                    <h5>{{ 'action-plans.modal.description' | lang }}</h5>
                    <textarea v-model="task.description" @focus="errorMsg = ''" type="text"></textarea>

                    <h5>{{ 'action-plans.modal.assignee' | lang }}</h5>
                    <input v-model="task.assignee" type="text" maxlength="50" />

                    <h5>{{ 'action-plans.modal.deadline' | lang }}</h5>
                    <Datepicker
                        v-model="task.deadline"
                        ref="calendar"
                        :inline="true"
                        :monday-first="true"
                        :disabled-dates="{ to: yesterday }"
                        :language="calendarLanguage"
                        @selected="handleDateSelected"
                        calendar-class="edit-task-calendar"
                    />

                </div>
                <div class="modal-footer">
                    <div class="btn" @click="doAccept">{{ 'action-plans.modal.save' | lang }}</div>
                    <div class="btn grey lighten" @click="closeOpenModal">{{ 'modals/cancel' | lang }}</div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { en, lv } from 'vuejs-datepicker/dist/locale';
    import moment from 'moment';
    import apServices from '@/services/action-plans'

    export default {
        name: "EditTask",
        components: { Datepicker },
        props: ["task"],
        mixins: [apServices],
        computed: {
            isEditView() {
                return this.task.mode === 'edit';
            },
        },
        data() {
            return {
                deadline: this.task.deadline,
                errorMsg: '',
                calendarLanguage: this.$root.languages.current === 'lv' ? lv : en,
                yesterday: new Date(moment().subtract(1, 'days'))
            }
        },
        mounted() {
            this.focusOnInput('textarea');
            this.toggleContentFixed();
        },
        destroyed() {
            this.toggleContentFixed();
        },
        methods: {
            toggleContentFixed() {
                let boxed = document.getElementById("boxed")

                if (!boxed) return;

                if (boxed.style.position === 'fixed') {
                    boxed.style.position = null;
                    boxed.style.width = null;
                    return;
                }

                boxed.style.position = 'fixed';
                boxed.style.width = 'calc(100% - 100px)';
            },

            async doAccept() {
                if (this.task.description.trim() === '') {
                    this.errorMsg = this.$options.filters.lang('action-plans.modal.empty-description');
                    return;
                }

                this.task.deadline = this.deadline;

                const saveTaskResponse =
                    this.isEditView ?
                        await this.updateTask(this.task.id, this.task) :
                        await this.saveTask(this.task);

                this.$store.commit('CLOSE_MODAL_ACCEPT', saveTaskResponse);
            },

            handleDateSelected(date) {
                const cal = $(".edit-task-calendar");
                const current = moment(this.task.deadline).format("ll");
                const selected = moment(date).format("ll");

                if (current === selected && !cal.hasClass("date-deselected")) {
                    cal.addClass("date-deselected");
                    this.deadline = null;
                    return;
                }

                cal.removeClass("date-deselected");
                this.deadline = date;
            }
        },
    }
</script>

<style lang="scss">
    .modal-edit-task {
        display: flex;
        justify-content: center;
        overflow: auto scroll;

        .modal-wrapper {
            display: block;
        }

        textarea {
            margin-bottom: 16px;
        }
    }

    @include datepicker-calendar;
</style>